import axios from "axios";
import { Dispatch } from "redux";
import { toast } from "@teamprevent/common/toasts";
import { loadAndTrack } from "redux-request-loading";
import { SUBMIT_QUESTIONNAIRE, submitQuestionnaireSuccess, submitInvalidQuestionnaire, questionnaireLoaded } from "@teamprevent/common/questionnaires/actions";
import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";

import { LOAD_MANAGER_PPQ_QUESTIONNAIRE } from "@teamprevent/common/ppq/actionTypes";

import { ppq } from "@teamprevent/common";

import { Payload } from "@neworbit/redux-helpers";

import { PpqApi } from "./PpqApi";
import { PpqReportApi } from "./PpqReportApi";
import { LOAD_PPQ_REPORT, LOAD_PPQ_REPORT_SUCCESS, VIEWED_PPQ_REPORT } from "./actionTypes";

export type LoadPpqReportSuccess = ({ type: typeof LOAD_PPQ_REPORT_SUCCESS }) & Payload<ppq.PpqReportModel>;

export type PpqAction = LoadPpqReportSuccess;

export const loadManagerQuestionnaire = buildLoadManagerQuestionnaire(new PpqApi(axios));

export function buildLoadManagerQuestionnaire(ppqApi: PpqApi) {
    return (ohCaseId: string, questionnaireKey: string) => {
        return async (dispatch: Dispatch) => {
            const response = await loadAndTrack(dispatch, LOAD_MANAGER_PPQ_QUESTIONNAIRE, ppqApi.loadManagerQuestionnaire(ohCaseId));
            if (response && response.data) {
                const questions = response.data.questions;
                dispatch(questionnaireLoaded({ questions, questionnaireKey }));
            }
        };
    };
}

export const submitQuestionnaire = buildSubmitQuestionnaire(new PpqApi(axios));

export function buildSubmitQuestionnaire(ppqApi: PpqApi) {
    return (questions: AnsweredQuestionWithId[], questionnaireKey: string) => {
        if (!questions.every(question => question.isValid)) {
            return (dispatch: Dispatch) => dispatch(submitInvalidQuestionnaire(questionnaireKey, true));
        }
        return async (dispatch: Dispatch) => {
            await loadAndTrack(dispatch, SUBMIT_QUESTIONNAIRE, ppqApi.submit(questions));
            toast.success("PPQ submitted successfully");
            dispatch(submitQuestionnaireSuccess(questionnaireKey));
        };
    };
}

export const buildLoadPpqReport = (ppqReportApi: PpqReportApi) => {
    return ({ ohCaseId, viewReportTaskId }: { ohCaseId: string; viewReportTaskId: string }) => {
        return async (dispatch: Dispatch) => {
            const response = await loadAndTrack(dispatch, LOAD_PPQ_REPORT, ppqReportApi.loadPpqReport(ohCaseId, viewReportTaskId));
            dispatch(loadPpqReportSuccess(response));
            await loadAndTrack(dispatch, VIEWED_PPQ_REPORT, ppqReportApi.view(ohCaseId, viewReportTaskId));
        };
    };
};

export const loadPpqReport = buildLoadPpqReport(new PpqReportApi(axios));

export const loadPpqReportSuccess = (ppqReport: ppq.PpqReportModel): PpqAction => {
    return {
        type: LOAD_PPQ_REPORT_SUCCESS,
        payload: ppqReport
    };
};
